import { fromNullable } from 'maybeasy';
import SVGIcon from '../SVGIcon';

interface Props {
  fill?: string;
}

function VerticalMenuIcon({ fill }: Props) {
  return (
    <SVGIcon viewBox="0 0 5 18" width="5" height="18" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 14C3.35457 14 4.25 14.8954 4.25 16C4.25 17.1046 3.35457 18 2.25 18C1.14543 18 0.25 17.1046 0.25 16C0.25 14.8954 1.14543 14 2.25 14ZM2.25 7C3.35457 7 4.25 7.89543 4.25 9C4.25 10.1046 3.35457 11 2.25 11C1.14543 11 0.25 10.1046 0.25 9C0.25 7.89543 1.14543 7 2.25 7ZM2.25 0C3.35457 0 4.25 0.89543 4.25 2C4.25 3.10457 3.35457 4 2.25 4C1.14543 4 0.25 3.10457 0.25 2C0.25 0.89543 1.14543 0 2.25 0Z"
        fill={fromNullable(fill).getOrElseValue('#0E0E0E')}
      />
    </SVGIcon>
  );
}

export default VerticalMenuIcon;
